<template>
  <div>
    <form id="formForgetPassword" class="forget-form" style="display:block;">
        <h3 class="font-green">Mot de passe oublié ?</h3>
        <p> Entrer l'email de votre compte pour réinitialiser votre mot de passe. </p>
        <div class="form-group">
            <input class="form-control placeholder-no-fix" type="text" autocomplete="off" placeholder="Email" v-model="email" required data-parsley-type="email">
        </div>
        <div class="form-actions">
            <a type="button" id="back-btn" class="btn yellow btn-outline" v-on:click="show.login = true">Retour</a>
            <a class="btn btn-success uppercase pull-right" v-on:click="sendEmail()">Envoyer</a>
        </div>
    </form>
  </div>
</template>

<script>

  import users from '../../requests/users.js'

  export default {
    created () {
    },
    props: ["show"],
    data(){
      return{
        email:""
      }
    },
    mounted:function(){
    },
    methods:{
      sendEmail(){
        $('#formForgetPassword').parsley().validate()
        if($("#formForgetPassword").parsley().isValid()){
          var parent = this;
          users.reset(this,this.email,function(err){
            if(err){
              toastr.error(err,"ERREUR");
            }
            else{
              toastr.success("Un email de réinitialisation de mot de passe vient de vous être envoyé.");
            }
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// forgetPassword.vue?2fe98025